<template>
  <section :class="sectionClass">
    <div :class="containerClass">
      <div :class="listClass">
        <div class="row row-cols-xxl-4 row-cols-xl-4 row-cols-lg-4 row-cols-md-2 row-cols-sm-2 row-cols-1 gx-0">
          <div v-for="feature in featureData" :key="feature.id" class="col">
            <div :class="itemClass">
              <div :class="iconClass">
                <i :class="feature.icon"></i>
              </div>
              <div :class="contentClass">
                <h6>{{ feature.title }}</h6>
                <p>{{ feature.subtitle }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeatureSection',
  props: {
    style_2: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      featureData: [
        { id: 1, icon: 'fas fa-truck', title: 'FREE DELIVERY', subtitle: 'For all orders over $120' },
        { id: 2, icon: 'fas fa-money-check', title: 'SAFE PAYMENT', subtitle: '100% secure payment' },
        { id: 3, icon: 'fal fa-comments-alt', title: '24/7 HELP CENTER', subtitle: 'Dedicated 24/7 support' },
        { id: 4, icon: 'fas fa-user-headset', title: 'FRIENDLY SERVICES', subtitle: '30 day satisfaction guarantee' }
      ]
    };
  },
  computed: {
    sectionClass() {
      return this.style_2 ? 'features-2__area d-ddark-bg' : 'features__area pt-20';
    },
    containerClass() {
      return `container ${this.style_2 ? 'custom-container' : ''}`;
    },
    listClass() {
      return this.style_2 ? 'features-2__lists pt-25 pb-25' : '';
    },
    itemClass() {
      return this.style_2 ? 'features-2__item' : 'features__item d-flex white-bg';
    },
    iconClass() {
      return this.style_2 ? 'features-2__icon' : 'features__icon mr-20';
    },
    contentClass() {
      return this.style_2 ? 'features-2__content' : 'features__content';
    }
  }
};
</script>

<style scoped>
/* Add any necessary custom styles here */
</style>
